import axios from "axios";
import React from "react";
import { message } from "antd";
import { createHashHistory } from "history";
const history = createHashHistory();
const instance = axios.create({
  // baseURL:'',
  timeout: 10000,
});

// instance.interceptors.request.use(config => {
//   let token = sessionStorage.getItem("token");
//   if (token) {
//     config.headers["Authorization"] = token;
//   } else {
//   }
//   return config;
// });
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error.response);
    if (error.toString().indexOf("401") > 0) {
      history.push("/");
      setTimeout(() => {
        message.warning("请重新登录");
      }, 500);
    }
    return Promise.reject(error);
  }
);

export default instance;
